import 'lib/mobile_detect_wrapper';
import _ from 'underscore';
import $ from 'jquery';
import signals from 'signals';
import Dispatcher from 'lib/dispatcher';
import Constants from 'config/constants';
import Breakpoint from 'lib/breakpoints';

const navigatorPlatform = navigator && (navigator.platform || '');

const _events = {
  changed: new signals.Signal(),
};

let _state = {};

const _initState = {
  isMobile: !!window.mobileDetect.mobile(),
  isTablet: !!window.mobileDetect.tablet(),
  isPhone: !!window.mobileDetect.phone(),
  isMac: navigatorPlatform.toUpperCase().indexOf('MAC') >= 0,
};

function _onWindowResize(currentViewport, previousViewport) {
  _setState({
    viewport: {
      current: currentViewport,
      previous: previousViewport,
    },
  });
}

function _setState(newState) {
  _state = _.extend(_state, newState);
  _events.changed.dispatch(_state);
}

function _getMeta(key) {
  $(`meta[name=${key}], meta[property=${key}]`).attr('content');
}

Breakpoint.bind(_onWindowResize);

const AppStore = {
  getState() {
    return _state;
  },
  get(key) {
    return _state[key];
  },
  meta(key) {
    return _getMeta(key);
  },
  init(state) {
    _state = _.extend(state, _initState);
  },
  bindToViewportChange(fn) {
    Breakpoint.bind(fn);
  },
  unbindFromViewportChange(fn) {
    Breakpoint.unbind(fn);
  },

  dispatcherIndex: Dispatcher.register((payload) => {
    const { action } = payload;
    switch (action.actionType) {
      case Constants.LOGOUT:
        $.ajax({
          url: 'users/sign_out',
          type: 'DELETE',
        })
          .done(() => {
            location.href = '/';
          })
          .error(() => {
            alert('Logout failed');
          });
        break;
      default:
        break;
    }

    return true;
  }),
};

window.AppStore = AppStore;

export default AppStore;
